import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'extraZero',
    standalone: false
})
export class ExtraZeroPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (Number.isInteger(value)) {
      if (value < 10) {
        return '0' + value;
      }
    }
    return value;
  }

}
